import React from 'react'
import iconPaste from '../svgs/icons.js'

export default function Curtains({ui_element_id, param_value, ui_element_svg_id}){
    
    let fill_style = {fill: "var(--switch_off_color)"}

    if (param_value.target_pos != param_value.curr_pos){
        fill_style = {fill: "var(--switch_on_color)"}
    }
    else fill_style = {filter: 'blur(1px)'}

    var iconSvg
    if (param_value.curr_pos > 80) iconSvg = iconPaste(ui_element_svg_id)
    else if (param_value.curr_pos > 60) iconSvg = iconPaste(ui_element_svg_id+'_1')
    else if (param_value.curr_pos > 40) iconSvg = iconPaste(ui_element_svg_id+'_2')
    else if (param_value.curr_pos > 20) iconSvg = iconPaste(ui_element_svg_id+'_3')
    else iconSvg = iconPaste(ui_element_svg_id+'_4')
   
    return(
        <div style={fill_style}>
            <div className={'icon'}>{iconSvg}</div>
        </div>
    )
}